import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { adminUsersApi } from '../../api/client'
import { useState } from 'react'

const API_URL = import.meta.env.VITE_API_URL || '/api'

export default function UsersPage() {
  const queryClient = useQueryClient()
  const [search, setSearch] = useState('')

  const { data: users = [], isLoading } = useQuery({
    queryKey: ['admin-users'],
    queryFn: () => adminUsersApi.list().then(r => r.data),
  })

  const deleteMutation = useMutation({
    mutationFn: (id) => adminUsersApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-users'] }),
  })

  const filtered = users.filter(u =>
    `${u.firstName} ${u.lastName} ${u.email} ${u.jobTitle}`.toLowerCase().includes(search.toLowerCase())
  )

  const handleDelete = (user) => {
    if (confirm(`Supprimer ${user.firstName} ${user.lastName} ?`)) {
      deleteMutation.mutate(user.id)
    }
  }

  if (isLoading) return <div className="loading-screen">Chargement...</div>

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Employés ({users.length})</h1>
        <Link to="/admin/users/new" className="btn btn-primary">+ Nouvel employé</Link>
      </div>

      <div className="card">
        <div style={{ marginBottom: '1rem' }}>
          <input
            type="search"
            placeholder="Rechercher..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ maxWidth: 300, padding: '0.5rem 0.9rem', borderRadius: 8, border: '1px solid #ddd', width: '100%' }}
          />
        </div>

        {filtered.length === 0 ? (
          <p style={{ color: '#888', textAlign: 'center', padding: '2rem' }}>
            {search ? 'Aucun résultat' : 'Aucun employé. '}
            {!search && <Link to="/admin/users/new" style={{ color: '#1a73e8' }}>Créer le premier</Link>}
          </p>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Nom</th>
                  <th>Poste</th>
                  <th>Email</th>
                  <th>Slug (profil)</th>
                  <th>Rôle</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(user => (
                  <tr key={user.id}>
                    <td>
                      <strong>{user.firstName} {user.lastName}</strong>
                      {user.company && <div style={{ fontSize: '0.8rem', color: '#888' }}>{user.company}</div>}
                    </td>
                    <td>{user.jobTitle || '—'}</td>
                    <td>{user.email}</td>
                    <td>
                      <a
                        href={`/card/${user.slug}`}
                        target="_blank"
                        rel="noopener"
                        style={{ color: '#1a73e8', fontSize: '0.85rem' }}
                      >
                        /card/{user.slug}
                      </a>
                    </td>
                    <td>
                      <span className={`badge ${user.roles?.includes('ROLE_ADMIN') ? 'badge-admin' : 'badge-user'}`}>
                        {user.roles?.includes('ROLE_ADMIN') ? 'Admin' : 'Employé'}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <Link to={`/admin/users/${user.id}/edit`} className="btn btn-outline btn-sm">Éditer</Link>
                        <a
                          href={`${API_URL}/cards/${user.slug}/vcf`}
                          className="btn btn-outline btn-sm"
                          title="Télécharger vCard"
                        >
                          vCard
                        </a>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(user)}
                          disabled={deleteMutation.isPending}
                        >
                          Suppr.
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
